import { createFileRoute } from "@tanstack/react-router"
import { procedureTypeSettingsStepsViewStaticData } from "src/views/ProcedureTypeSettingsStepsView/constants"
import { ProcedureTypeSettingsStepsView } from "src/views/ProcedureTypeSettingsStepsView/ProcedureTypeSettingsStepsView"

export const Route = createFileRoute(
	"/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/$procedureTypeId/steps/",
)({
	component: ProcedureTypeSettingsStepsView,
	staticData: procedureTypeSettingsStepsViewStaticData,
})
